import React, { type CSSProperties, type ReactNode } from 'react';

import classnames from 'classnames';

import { type ThemedColors } from '../../types/themed-colors';

import styles from './Spinner.module.scss';

export type SpinnerProps = {
    color?: ThemedColors;
    inner?: ReactNode;
    size: CSSProperties['width'];
} & React.HTMLAttributes<HTMLDivElement>;

export const Spinner = ({ color = 'inherit', size = 24, inner, ...rest }: SpinnerProps) => {
    return (
        <div
            className={styles.container}
            style={
                {
                    '--spinner-size': typeof size === 'number' ? `${size}px` : size
                } as CSSProperties
            }
            {...rest}
        >
            <div className={styles.spinnerContainer}>
                <div className={classnames(styles.spinner, styles[color])} />
                {inner && <span className={styles.inner}>{inner}</span>}
            </div>
        </div>
    );
};
